



































import { Component, Vue } from 'vue-property-decorator'
import * as firebase from 'firebase/app'

@Component({})
export default class ChangePassword extends Vue {
  isModalOpen: boolean = false
  loading: boolean = false
  currentPassword: string = ''
  newPassword: string = ''
  email: string = this.$store.state.auth.user.email

  errorCode: string = ''
  errorMessage: string = ''

  openModal() {
    this.newPassword = ''
    this.loading = false
    this.errorCode = ''
    this.errorMessage = ''

    this.isModalOpen = true
  }

  async save() {
    this.errorCode = ''
    this.loading = true

    try {
      await firebase.auth().signInWithEmailAndPassword(this.email, this.currentPassword)

      const user = firebase.auth().currentUser

      if (!user) {
        throw new Error('Not currently logged in')
      }

      await user.updatePassword(this.newPassword)

      this.isModalOpen = false

      this.$buefy.notification.open('Password changed')
    } catch (error) {
      this.errorCode = error.code
      this.errorMessage = error.message

      console.error(error)
    } finally {
      this.newPassword = ''
      this.currentPassword = ''
    }

    this.loading = false
  }
}
